import { BuilderConfig } from '@/types/builder';

import RoomstayBlogNovacancy, { BlogNovacancyProps } from './roomstay-blog-novacancy';

    export const RoomstayBlogNovacancyBuilderConfig = {
        name: 'Novacancy Form',
        inputs: [
            {
                name: 'welcomeMessage',
                type: 'string',
                defaultValue: '',
            },
            {
                name: 'image',
                type: 'file',
                defaultValue: '',
            },
            {
                name: 'time',
                type: 'string',
                defaultValue: '',
            },
            {
                name: 'location',
                type: 'string',
                defaultValue: '',
            },
            {
                name: 'description',
                type: 'html',
                defaultValue: '',
            },
            {
                name: 'titleForm',
                type: 'string',
            },
            {
                name: 'buttonText',
                type: 'string',
            },
        ],
    };

const builderConfig: BuilderConfig<BlogNovacancyProps> = {
    component: RoomstayBlogNovacancy,
    config: RoomstayBlogNovacancyBuilderConfig,
};

export default builderConfig;
